module.exports = __webpack_public_path__ + "static/img/zhizhen.5a8d3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhizhen.png
// module id = 0v3n
// module chunks = 1